// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1NhfF","inputDescription":"styles_inputDescription__3PjC8"};